import { Typography } from "@mui/material";
import styled from "styled-components";
import { Button } from "../../components";

export const BannerContainer = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  position: absolute;
  z-index: 3;
  display: flex;
  flex-direction: column;
  width: 100vw;
  max-width: 30rem;
  height: 100vh;
  background-color: #fff;
  * {
    font-family: Montserrat;
    white-space: pre-line;
  }
`;
export const BannerHeader = styled.div`
  width: calc(30rem - 2rem);
  min-height: 5rem;
  position: absolute;
  z-index: 2;

  display: flex;
  gap: 1rem;
  align-items: center;

  padding: 1rem;

  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.7) 0%,
    rgba(0, 0, 0, 0) 100%
  );
`;

export const BannerImage = styled.img`
  width: 100%;
  height: 15rem;
  object-fit: cover;
`;
export const ShareContainer = styled.div`
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 70%;
  margin-top: -1.8rem;
  padding: 0.8rem 1.5rem;
  border-radius: 2rem;
  background: #fefeff;
  box-shadow: 0px 20px 20px 0px rgba(90, 90, 90, 0.1);
  backdrop-filter: blur(10.873126983642578px);
`;
export const BannerTitle = styled(Typography)`
  color: #120d26;
  font-weight: 700;
  margin: 1rem 2rem 0 2rem;
  font-size: 35px;
  text-transform: uppercase;
`;
export const BannerDescription = styled(Typography)`
  margin: 1.5rem 2rem 0 2rem;
  margin-bottom: 10rem;
`;
export const BuyButton = styled(Button)`
  position: fixed;
  display: flex;
  gap: 1rem;
  bottom: 0.5rem;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 3.5rem;
  font-weight: 700;
  font-size: 1rem;
  padding: 1rem 1.5rem;
  width: max-content;

  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    border-radius: 100%;
    background-color: #000;
    svg {
      color: #fff;
    }
  }
`;
